import lazyScreen from '../utils/lazyScreen';
const DeployCash = lazyScreen(() => import('../pages/deploy/DeployCash/index.js'), 'pages/deploy/DeployCash/index.js');
const DeployVendor = lazyScreen(() => import('../pages/deploy/DeployVendor/index.js'), 'pages/deploy/DeployVendor/index.js');
const DeployInventory = lazyScreen(() => import('../pages/deploy/DeployInventory/index.js'), 'pages/deploy/DeployInventory/index.js');
const DeployAsset = lazyScreen(() => import('../pages/deploy/DeployAsset/index.js'), 'pages/deploy/DeployAsset/index.js');
const DeployEquipment = lazyScreen(() => import('../pages/deploy/DeployEquipment/index.js'), 'pages/deploy/DeployEquipment/index.js');
const DeployGLAccounts = lazyScreen(() => import('../pages/deploy/GLAccounts/index.js'), 'pages/deploy/GLAccounts/index.js');
const DeployEmployee = lazyScreen(() => import('../pages/deploy/DeployEmployee/index.js'), 'pages/deploy/DeployEmployee/index.js');

export default [
    {
        path: '/deploy/DeployVendor',
        component: DeployVendor
    },
    {
        path: '/deploy/DeployInventory',
        component: DeployInventory
    },
    {
        path: '/deploy/DeployAsset',
        component: DeployAsset
    },
    {
        path: '/deploy/DeployEquipment',
        component: DeployEquipment
    },
    {
        path: '/deploy/DeployCash',
        component: DeployCash
    },
    {
        path: '/deploy/GLAccounts',
        component: DeployGLAccounts
    },
    {
        path: '/deploy/DeployEmployee',
        component: DeployEmployee
    }
];
